import { FormType } from '../../types/types';

export const getFormTypeFromPathname = (pathname: string): FormType => {
  if (!pathname.includes('form')) {
    throw new Error('Form type section not found in pathname');
  }

  const splittedPathname = pathname.split('/');
  const forSectionIndex = splittedPathname.indexOf('form');
  let formTypeSection = splittedPathname[forSectionIndex + 2];

  if (formTypeSection?.includes('?')) {
    formTypeSection = formTypeSection.split('?')[0];
  }

  if (formTypeSection === 'add') {
    return 'insert';
  }

  return formTypeSection as FormType;
};
